// extracted by mini-css-extract-plugin
export var leftSide = "socialLinks-module--leftSide--WeiMV";
export var link = "socialLinks-module--link--71cAC";
export var links = "socialLinks-module--links--5MIkr";